import { ShieldCheck, Award } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { TRUST } from "@/data/content";

export const TrustBanner = () => {
  return (
    <section
      data-testid="trust-banner"
      className="relative overflow-hidden border-y border-saffron/25 bg-aero-navy"
    >
      <div className="blueprint-grid absolute inset-0 opacity-30" />
      <div className="relative mx-auto max-w-[1400px] px-5 py-16 sm:px-8 sm:py-20">
        <Reveal>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-4">
              <ShieldCheck className="mt-1 h-8 w-8 shrink-0 text-saffron" />
              <div>
                <p className="font-heading text-2xl font-bold leading-tight text-ink sm:text-3xl">
                  {TRUST.banners[0]}
                </p>
                <p className="mt-1 font-heading text-lg font-medium text-saffron sm:text-xl">
                  {TRUST.banners[1]}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 self-start rounded-full border border-saffron/40 px-4 py-2 sm:self-auto">
              <Award className="h-4 w-4 text-saffron" />
              <span className="font-heading text-xs uppercase tracking-[0.18em] text-ink">
                Est. 1974
              </span>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TRUST.lines.map((line, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full border-l border-saffron/40 pl-5">
                <span className="font-heading text-sm font-bold text-saffron">
                  0{i + 1}
                </span>
                <p className="mt-2 font-body text-sm leading-relaxed text-steel">
                  {line}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
